import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import addFraudProtection from 'components/utils/addFraudProtection'
import { paymentMethodsDispatchers as mergeProps } from 'reduxModules/users/dispatchers'
import { paymentMethodSelector as stateSelector } from 'reduxModules/forms/paymentMethod/selectors'

import PaymentMethodForm from '../../generic/PaymentMethodForm'
import CardFieldsAlert from '../../generic/PaymentMethodForm/CardFieldsAlert'
import PaymentMethodList from './PaymentMethodList'
import AddPayPal from './AddPayPal'
import CaptchaStandalone from '../../CaptchaStandalone/_lazy'
import getCardIcon from '../../utils/getCardIcon'

// the logo PaymentMethodForm's PayPal option shows
const PAYPAL_LOGO =
  'https://assets.braintreegateway.com/payment_method_logo/paypal.png'
import './styles.css'

class PaymentMethods extends Component {
  constructor(props) {
    super(props)
    this.saveCreditCard = this.saveCreditCard.bind(this)
  }

  componentDidMount() {
    this.props.getBraintreeClientToken()
    this.props.loadPaymentMethods()
  }

  saveCreditCard() {
    const {
      clientToken,
      savePaymentMethod,
      showFraudProtectionError,
      tokenizer,
      recaptcha
    } = this.props

    addFraudProtection(
      savePaymentMethod,
      [tokenizer, recaptcha],
      clientToken,
      showFraudProtectionError
    )
  }

  render() {
    const {
      paymentMethodsCount,
      showForm,
      showNewPaymentMethodForm,
      hideNewPaymentMethodForm,
      clientToken,
      recaptcha,
      savePayPal,
      showFraudProtectionError,
      payWithCreditCard
    } = this.props

    return (
      <div id="PaymentMethods" className="account-section">
        <h3 className="account-section__title">payment methods</h3>
        {paymentMethodsCount !== 0 && (
          <div className="payment-methods-content">
            <PaymentMethodList />
          </div>
        )}
        {paymentMethodsCount === 0 && (
          <p className="payment-methods-empty-content">
            You don&apos;t have any payment methods.
          </p>
        )}
        {!showForm && (
          <div className="add-payment-method">
            <div className="accepted-cards">
              <img src={getCardIcon('visa')} alt="visa" />
              <img src={getCardIcon('master-card')} alt="mastercard" />
              <img src={getCardIcon('american-express')} alt="amex" />
              <img src={PAYPAL_LOGO} alt="paypal" className="paypal-logo" />
            </div>
            <button
              type="button"
              className="add-payment-button"
              onClick={() => showNewPaymentMethodForm()}
            >
              <i className="icon-plus" />
              add payment method
            </button>
          </div>
        )}
        {showForm && (
          <div className="create-payment-methods">
            <h3 className="account-section__title">New Payment Method</h3>
            {/* SPEC-098: the same Credit Card / PayPal choice as checkout.
                Credit Card keeps the card form below; PayPal puts its own
                button in the same place (approving it is the save). */}
            <PaymentMethodForm authorization={clientToken} enablePaypal>
              {!payWithCreditCard && (
                <AddPayPal
                  clientToken={clientToken}
                  recaptcha={recaptcha}
                  savePayPal={savePayPal}
                  showFraudProtectionError={showFraudProtectionError}
                />
              )}
              {/* Invisible unless Cloudflare wants a click (as on the auth
                  screens); Save waits for its token */}
              <div className="captcha-container">
                <CaptchaStandalone appearance="interaction-only" />
              </div>
              {payWithCreditCard && <CardFieldsAlert />}
              <div className="buttons-subcontainer">
                {paymentMethodsCount > 0 && (
                  <button
                    type="button"
                    className="cancel-payment-btn"
                    onClick={() => hideNewPaymentMethodForm()}
                  >
                    cancel
                  </button>
                )}
                {payWithCreditCard && (
                  <button
                    type="submit"
                    className="submit-btn"
                    onClick={() => this.saveCreditCard()}
                    disabled={!recaptcha?.token}
                  >
                    Save Credit Card
                  </button>
                )}
              </div>
            </PaymentMethodForm>
          </div>
        )}
      </div>
    )
  }
}

PaymentMethods.propTypes = {
  getBraintreeClientToken: PropTypes.func.isRequired,
  showNewPaymentMethodForm: PropTypes.func.isRequired,
  hideNewPaymentMethodForm: PropTypes.func,
  loadPaymentMethods: PropTypes.func,
  showForm: PropTypes.bool.isRequired,
  clientToken: PropTypes.string.isRequired,
  paymentMethodsCount: PropTypes.number,
  savePaymentMethod: PropTypes.func,
  savePayPal: PropTypes.func,
  payWithCreditCard: PropTypes.bool,
  showFraudProtectionError: PropTypes.func,
  tokenizer: PropTypes.any,
  recaptcha: PropTypes.any
}

PaymentMethods.defaultProps = {
  hideNewPaymentMethodForm: () => {},
  loadPaymentMethods: () => {},
  paymentMethodsCount: 0,
  savePaymentMethod: () => {},
  savePayPal: () => Promise.resolve(false),
  payWithCreditCard: true,
  showFraudProtectionError: () => {},
  tokenizer: null,
  recaptcha: null
}

export default connect(stateSelector, null, mergeProps)(PaymentMethods)
